import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import UsersSummary from './UsersSummary';
import SectionHeader from './SectionHeader';
import TableLayout from './UsersTable/TableLayout';
import ConnectedModals from './ConnectedModals';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import { AppSelectors } from '../../../Redux/modules/app/selectors';
import UsersFooter from './UsersFooter';
import { ColumnHeaders, InviteMapper, StatusFilterMapper } from '../constants';

const Users = (props) => {
  const usersColumns = [
    {
      Header: gettext(ColumnHeaders.USERS),
      accessor: 'name',
    },
    {
      Header: gettext(ColumnHeaders.ADMIN),
      accessor: 'is_org_admin',
      sortType: 'basic',
    },
    {
      Header: gettext(ColumnHeaders.SEARCH),
      accessor: 'assigned_to_search',
      sortType: 'basic',
    },
    {
      Header: gettext(ColumnHeaders.LAST_LOGIN),
      accessor: 'last_login',
      sortType: 'basic',
    },
  ];
  if (props.isTeamManagement) {
    usersColumns.splice(1, 0, {
      Header: gettext(ColumnHeaders.TEAMS),
      accessor: 'teams',
      sortType: 'basic',
    });
  }

  const trialEndDate = moment(props.usersData?.search_status?.end_date).format('MMMM, DD, YYYY');

  const invitedUsersCount = props.users.filter(
    (user) => user.status.invite_status === InviteMapper.INVITE_SENT || user.status.type === StatusFilterMapper.PENDING,
  ).length;

  return (
    <div>
      <Helmet>
        <title>{gettext('Users')}</title>
      </Helmet>
      <ConnectedModals
        isTrial={props.isTrial}
        availableSubscriptions={props.availableSubscriptions}
        trialEndDate={trialEndDate}
        actions={props.actions}
      />
      <UsersSummary
        isLoading={props.isSummaryLoading}
        totalAdmins={props.totalAdmins}
        totalUsers={props.users.length}
        invitedUsersCount={invitedUsersCount}
        usersData={props.usersData}
        isLoadingUsersList={props.isUsersLoading}
        availableSubscriptions={props.availableSubscriptions}
        totalSubscriptions={props.totalSubscriptions}
        isTrial={props.isTrial}
        trialEndDate={trialEndDate}
        users={props.users}
      />
      <SectionHeader
        availableSubscriptions={props.availableSubscriptions}
        trialEndDate={trialEndDate}
        isTrial={props.isTrial}
        teams={props.usersData.teams}
      />
      <TableLayout
        isLoading={props.isUsersLoading}
        totalAdmins={props.totalAdmins}
        totalUsers={props.users.length}
        users={props.users}
        fetchUsers={props.fetchUsers}
        columns={usersColumns}
        type="orgUsers"
        actions={props.actions}
      />
      <UsersFooter usersData={props.usersData} isTrial={props.isTrial} />
    </div>
  );
};

const mapSateToProps = (state) => {
  return {
    isUsersLoading: UsersSelectors.isLoadingUsersSelector(state),
    isInvitesLoading: UsersSelectors.isLoadingInvitesSelector(state),
    isSummaryLoading: UsersSelectors.isLoadingSummarySelector(state),
    isTeamManagement: AppSelectors.isTeamManagementSelector(state),
  };
};

Users.propTypes = {
  isUsersLoading: PropTypes.bool,
  isSummaryLoading: PropTypes.bool,
  isTeamManagement: PropTypes.bool,
  isTrial: PropTypes.bool,
  users: PropTypes.array,
  fetchUsers: PropTypes.func,
  usersData: PropTypes.object,
  actions: PropTypes.array,
  totalAdmins: PropTypes.number,
  availableSubscriptions: PropTypes.number,
  totalSubscriptions: PropTypes.number,
};

export default connect(mapSateToProps)(Users);
